import axios from 'axios'

export default {
  getAuthStatus (token: string) {
    return axios.get('/imanage/authStatus', { headers: { 'X-CLOSD-IMCONFIG': token } })
  },
  getAuthURL () {
    return axios.get('/imanage/authUrl')
  },
  getAuthCode (data: any) {
    return axios.post('/imanage/authCode', data)
  },
  getIManageFilePicker (token: string, params = {}) {
    return axios.get('/imanage/dialog/filePicker', { params, headers: { 'X-CLOSD-IMCONFIG': token } })
  },
  getIManageFolderPicker (token: string) {
    return axios.get('/imanage/dialog/folderPicker', { headers: { 'X-CLOSD-IMCONFIG': token } })
  },
  postFildersToIManage (mnemo: string, data: any, token: string) {
    return axios.post(`/room/${mnemo}/imanageExport`, data, { headers: { 'X-CLOSD-IMCONFIG': token } })
  },
}
